import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        flexGrow: 1,
        position: 'relative' as const
    },
    cancelButton: {
        position: 'absolute' as const,
        top: '1rem',
        right: '1rem'
    },
    userContainer: {
        backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
            '#FFFFFF',
        padding: '2rem'
    },
    userHeaderContainer: { paddingBottom: '1rem' },
    actionButton: {
        marginTop: '3px',
        marginRight: '1rem'
    },
    userDetailContainer: {
        paddingBottom: '.2rem',
        '&:last-child': { paddingBottom: 0 }
    },
    userDetailLabel: { display: 'inline' as const },
    userDetailText: { display: 'inline' as const },
    userFullName: {
        fontSize: '1.75rem',
        fontWeight: 'bold' as const
    },
    userStatusIcon: {
        marginLeft: '.75rem',
        paddingTop: '.2rem'
    },
    userTabsContainer: {
        borderTop: '1px solid #BFBFBF',
        borderBottom: '1px solid #BFBFBF'
    },
    userTab: { padding: 0 },
    indicator: {
        height: '5px',
        background: theme?.app?.clientTheme.colors.highlightColor1 ||
            '#EDDA26'
    }
});